import clsx from 'clsx';

import { formatDate } from '../../utilities';
import MessageContent from './MessageContent';
import { checkIsComplex } from './contentCheck';
import { EmptyMessage, Loading } from '../../components';
import { getMessageClassName } from './getMessageClassName';
import type { Item } from './useMessagesForContact';

type MessagesListProps = {
  data: Item[];
  initializing: boolean;
};

export const MessagesList: React.FC<MessagesListProps> = ({
  data,
  initializing,
}) => {
  if (initializing) return <Loading className="flex-1" />;

  if (!data.length) {
    return (
      <EmptyMessage className="flex-1">
        There are no Messages for this Contact.
      </EmptyMessage>
    );
  }

  return (
    <div className="flex flex-col gap-y-lg flex-1 overflow-y-auto max-w-full">
      {data.map(message => {
        const isUser = message.author_type === 'User';
        const isComplex = checkIsComplex(message.content);

        return (
          <div
            key={message.id}
            className={clsx(
              'w-full flex',
              isUser ? 'justify-end' : 'justify-start'
            )}
          >
            <div
              className={clsx(
                isComplex ? 'w-[70%]' : 'max-w-[70%]',
                'rounded-sm border-l-4 p-lg',
                getMessageClassName(message) || 'bg-bg'
              )}
            >
              <div className="text-text text-medium break-normal whitespace-pre-wrap">
                <MessageContent
                  isComplex={isComplex}
                  content={message.content}
                />
              </div>
              <div className="mt-md text-tiny font-semibold">
                {[
                  message.conversation_channel,
                  message.author_type,
                  formatDate(message.message_timestamp),
                ]
                  .filter(Boolean)
                  .join(' • ')}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
